import { TASK_LIST, TASK_VARIANTS, Experiment } from './constants.tsx';

export const DEVOPS = {
	taskList: TASK_LIST,
	taskVariants: TASK_VARIANTS,
	experiment: Experiment,
} as const;
